import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { Incident } from '@shared/models/entities/incident.model';

@Injectable({ providedIn: 'root' })
export class IncidentsService extends ApiBaseService<Incident> {
  constructor() {
    super('incidents'); // → /incidents, /incidents/search
  }

  /** MPXR y Justificado (solo Representante / Administrador Epione / Medtronic; lo valida el API). */
  /** Sugerencia del modelo (calidad / no calidad) para un texto. */
  async classify(description: string, reason?: string | null): Promise<{ qualityClass: string | null; qualityScore: number | null } | null> {
    const r: any = await this.request<any>('incidents/classify', 'POST', { description, reason: reason ?? null });
    return r?.data?.[0] ?? r?.data ?? null;
  }

  /** Clasifica y completa código / lote de las incidencias viejas del alcance. */
  async backfill(): Promise<number> {
    const r: any = await this.request<any>('incidents/classify', 'POST', { backfill: true });
    return Number((r?.data?.[0] ?? r?.data)?.updated ?? 0);
  }

  async review(id: string, change: { mpxr?: string | null; justified?: boolean; quality?: 'CALIDAD' | 'NO CALIDAD' }): Promise<any> {
    const r: any = await this.request<any>('incidents/review', 'POST', { id, ...change });
    return r?.data?.[0] ?? r?.data ?? null;
  }
}
